import { Badge, Box, IconButton, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { config_path } from '../router/config.path';
import { GetIconColor } from '../theme/main_style';
import { cache, order_key } from '../utils/cache';
import { dataUtil } from '../wsclient/crmservices/dataUtil';
import AlertComponent from './Alert';
import ConfirmComponent from './Confirm';
import { CartIcon } from './IconComponent';
import LoadingComponent from './Loading';
import OrderSupplyMethod from '../pages/orders/OrderSupplyMethod';

export default function CartComponent(props) {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [message, setMessage] = useState();
    const [showProcessing, setShowProcessing] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [currentLocation, setCurrentLocation] = useState(null);
    const [currentLocationStatus, setCurrentLocationStatus] = useState('pending');
    const { palette, breakpoints } = useTheme();
    const appConfig = cache.getAppConfig();
    const carts = cache.getCartItem();
    let totalCart = dataUtil.getTotalCartQuantity(carts ? carts : []);

    useEffect(() => {
        getLocation();
        onLoadCartItems();
        cache.setCartItemListener(onLoadCartItems);
    }, [totalCart]);

    useEffect(() => {
        if (props.isReloadCart) {
            onLoadCartItems();
        }
    }, [props.isReloadCart])

    const getLocation = () => {
        let isAllowOrder = cache.getAllowOrderContact();
        if((window.natively.isIOSApp || window.natively.isAndroidApp) && isAllowOrder)
		{
			const locationService = new NativelyLocation();  // eslint-disable-line
			const location_callback = function (resp) {
					let currentLocation = {
						lat: resp.latitude,
						lon: resp.longitude,
					}
					setCurrentLocation(currentLocation);
					setShowProcessing(false);
					setCurrentLocationStatus('done');
			};
			const minAccuracy = 50;
			const accuracyType = "Best";
			const priority_android = "BALANCED";
			locationService.current(minAccuracy, accuracyType, priority_android, location_callback);
		}
        else
        {
            navigator.geolocation.getCurrentPosition((location) => {
                var currentLocation = {
                    lat: location.coords.latitude,
                    lon: location.coords.longitude,
                }
                setCurrentLocation(currentLocation);
                setShowProcessing(false);
                setCurrentLocationStatus('done');
            }, (err) => {
                console.log('getLocation err', err)
                setShowProcessing(false);
                setCurrentLocationStatus('done');
            }, {
                timeout: 60000,
                enableHighAccuracy: false
            });
        }
    }

    const onLoadCartItems = (newCart) => {
        const cart = newCart ? newCart : cache.getCartItem();
        const statusOrder = cache.getCacheByKey(order_key.status_order, true);
        let total = dataUtil.getTotalCartQuantity(cart ? cart : []);
        if (statusOrder == 'COMPLETED') {
            cache.clearOrder();
            total = 0;
        }
    }

    const openCart = async () => {
        let orders = cache.getOrders();
        let route = config_path.orders_cart_items;
        if (orders.init_draft_order) {
            navigate(route, { state: { action: 're_estimate', from: props.from, redirect_path: props.redirect_path, type: props.type } })
        } else {
            setShowProcessing(true);
            let initOrder = await dataUtil.onInitOrder({ location: currentLocation, appConfig: appConfig });
            setShowProcessing(false);
            let fulfilled_by = initOrder && initOrder.fulfilled_by ? initOrder.fulfilled_by : null;
            if (initOrder) {
                await cache.initDraftOrder(true);
                await cache.changeOrderType(initOrder.supply_method)
                if (initOrder.supply_method == 'DELIVERY') {
                    await cache.updateDeliveryMerchant(fulfilled_by)
                    await cache.setDeliveryAddress(initOrder.customer_address)
                }
                else {
                    await cache.setPickUpStore(fulfilled_by);
                }
                if (fulfilled_by) {
                    navigate(route, { state: { action: 're_estimate', from: props.from, redirect_path: props.redirect_path, type: props.type } })
                } else {
                    setShowConfirm(true);
                }
            } else {
                showMessage({ status: true, message: t('EXCEPTION_PROCESS') })
            }
        }
    }

    const showMessage = ({ status, title, message, otherMessage, callBackFn }) => {
        setShowProcessing(false);
        setMessage({ show: status, title: title, content: message, otherMessage, callBackFn: callBackFn ? callBackFn : () => setMessage({}) });
    }

    const reloadFunc = async (params) => {
        if (props.reloadFunc) {
            await props.reloadFunc(params);
        } else {
            setShowProcessing(true);
            try {
                let fulfilled_by = params.fulfilled_by;
                if (params.supply_method == 'PICK_UP' || params.supply_method == 'DIRECT_SALE') {
                    await cache.initOrder({ type: params.supply_method, fulfilled_by: [] });
                    await cache.setPickUpStore(params.fulfilled_by);
                } else {
                    let store = await dataUtil.getFulfillmentStoreDetail({ supply_method: params.supply_method, customer_address: params.customer_address });
                    if (store) {
                        fulfilled_by = store;
                    }
                    params.fulfilled_by = fulfilled_by
                    await cache.initOrder({ type: params.supply_method, fulfilled_by: fulfilled_by });
                    await cache.setDeliveryAddress(params.customer_address);
                }
            } catch (ex) {
                showMessage({ status: true, message: t('EXCEPTION_PROCESS') })
            }
            setShowProcessing(false);
        }
    }

    return (
        <Box sx={{
            [breakpoints.down('md')]: {
                position: 'relative',
            },
            marginLeft:0
        }}>
            {carts!=null && carts.length>0 && props.from!='shopping_cart' && <IconButton size='large' sx={{
                position: 'fixed',
                bottom: 100,
                right: 24,
                zIndex: 100,
                backgroundColor: palette.primary.main,
                ':hover': {
                    backgroundColor: palette.primary.main,
                }
            }} onClick={() => openCart()}>
                <Badge badgeContent={totalCart} color="error" sx={{ "& .MuiBadge-badge": { color: palette.common.white } }}>
                    <CartIcon color={GetIconColor().white} />
                </Badge>
            </IconButton>}
            {currentLocationStatus == 'done' && 
            <Box>
                {props.includeOrderMethod && <OrderSupplyMethod
                    loading = {props.loading}
                    // setShowProcessingSupply={props.setShowProcessingSupply}
                    // showProcessingSupply={props.showProcessingSupply}
                    currentLocation={currentLocation}
                    reloadFunc={reloadFunc}
                />}
            </Box>}
            {showProcessing && <LoadingComponent showLoading={showProcessing} />}
            {message && message.show && <AlertComponent
                isOpen={message.show}
                message={message.content}
                otherMessage={message.otherMessage ? message.otherMessage : null}
                onClose={message.callBackFn}
            />}
            {showConfirm && <ConfirmComponent
                isOpen={showConfirm}
                title={t('warning')}
                message={t('DELIVERY_VALIDATION_LOCATION_CONFIRM')}
                onClose={() => setShowConfirm(false)}
                onConfirm={() => setShowConfirm(false)}
            />}
        </Box>
    )
}
